import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function roundQuantity(quantity) {
  return Math.round(quantity * 10000 + Number.EPSILON) / 10000;
}

function transformUom(uom) {
  if (!uom) {
    return null;
  }
  return uom.toLowerCase();
}

const IngredientQuantity = ({ quantity, uom }) => {
  if (!_.isNumber(quantity)) {
    return null;
  }
  return (
    <>
      {roundQuantity(quantity)} {transformUom(uom)}
    </>
  );
};

IngredientQuantity.propTypes = {
  quantity: PropTypes.number,
  uom: PropTypes.string
};

export default IngredientQuantity;
